"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_ADDRESS = exports.RESET_FIND_ADDRESS_ERROR = exports.RESET_ADDRESS_SEARCH = exports.ENTER_MANUAL_ADDRESS = void 0;
// ADDRESS ACTION CONSTANTS
var SELECT_ADDRESS = exports.SELECT_ADDRESS = 'SELECT_ADDRESS';
var RESET_ADDRESS_SEARCH = exports.RESET_ADDRESS_SEARCH = 'RESET_ADDRESS_SEARCH';
var ENTER_MANUAL_ADDRESS = exports.ENTER_MANUAL_ADDRESS = 'ENTER_MANUAL_ADDRESS';
var RESET_FIND_ADDRESS_ERROR = exports.RESET_FIND_ADDRESS_ERROR = 'RESET_FIND_ADDRESS_ERROR';